import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::create
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:40
* @route '/app/admin/newsletters/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/app/admin/newsletters/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::create
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:40
* @route '/app/admin/newsletters/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::create
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:40
* @route '/app/admin/newsletters/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::create
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:40
* @route '/app/admin/newsletters/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::create
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:40
* @route '/app/admin/newsletters/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::create
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:40
* @route '/app/admin/newsletters/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::create
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:40
* @route '/app/admin/newsletters/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::store
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:48
* @route '/app/admin/newsletters'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/admin/newsletters',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::store
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:48
* @route '/app/admin/newsletters'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::store
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:48
* @route '/app/admin/newsletters'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::store
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:48
* @route '/app/admin/newsletters'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::store
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:48
* @route '/app/admin/newsletters'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::show
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:66
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
export const show = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/admin/newsletters/{adminNewsletter}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::show
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:66
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
show.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return show.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::show
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:66
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
show.get = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::show
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:66
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
show.head = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::show
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:66
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
const showForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::show
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:66
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
showForm.get = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::show
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:66
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
showForm.head = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::edit
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:109
* @route '/app/admin/newsletters/{adminNewsletter}/edit'
*/
export const edit = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/app/admin/newsletters/{adminNewsletter}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::edit
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:109
* @route '/app/admin/newsletters/{adminNewsletter}/edit'
*/
edit.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return edit.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::edit
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:109
* @route '/app/admin/newsletters/{adminNewsletter}/edit'
*/
edit.get = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::edit
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:109
* @route '/app/admin/newsletters/{adminNewsletter}/edit'
*/
edit.head = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::edit
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:109
* @route '/app/admin/newsletters/{adminNewsletter}/edit'
*/
const editForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::edit
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:109
* @route '/app/admin/newsletters/{adminNewsletter}/edit'
*/
editForm.get = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::edit
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:109
* @route '/app/admin/newsletters/{adminNewsletter}/edit'
*/
editForm.head = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::update
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:128
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
export const update = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/admin/newsletters/{adminNewsletter}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::update
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:128
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
update.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return update.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::update
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:128
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
update.put = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::update
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:128
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
const updateForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::update
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:128
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
updateForm.put = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::send
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:147
* @route '/app/admin/newsletters/{adminNewsletter}/send'
*/
export const send = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(args, options),
    method: 'post',
})

send.definition = {
    methods: ["post"],
    url: '/app/admin/newsletters/{adminNewsletter}/send',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::send
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:147
* @route '/app/admin/newsletters/{adminNewsletter}/send'
*/
send.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return send.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::send
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:147
* @route '/app/admin/newsletters/{adminNewsletter}/send'
*/
send.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::send
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:147
* @route '/app/admin/newsletters/{adminNewsletter}/send'
*/
const sendForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: send.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::send
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:147
* @route '/app/admin/newsletters/{adminNewsletter}/send'
*/
sendForm.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: send.url(args, options),
    method: 'post',
})

send.form = sendForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::cancel
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:161
* @route '/app/admin/newsletters/{adminNewsletter}/cancel'
*/
export const cancel = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

cancel.definition = {
    methods: ["post"],
    url: '/app/admin/newsletters/{adminNewsletter}/cancel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::cancel
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:161
* @route '/app/admin/newsletters/{adminNewsletter}/cancel'
*/
cancel.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return cancel.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::cancel
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:161
* @route '/app/admin/newsletters/{adminNewsletter}/cancel'
*/
cancel.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::cancel
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:161
* @route '/app/admin/newsletters/{adminNewsletter}/cancel'
*/
const cancelForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::cancel
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:161
* @route '/app/admin/newsletters/{adminNewsletter}/cancel'
*/
cancelForm.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

cancel.form = cancelForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::pause
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:176
* @route '/app/admin/newsletters/{adminNewsletter}/pause'
*/
export const pause = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

pause.definition = {
    methods: ["post"],
    url: '/app/admin/newsletters/{adminNewsletter}/pause',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::pause
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:176
* @route '/app/admin/newsletters/{adminNewsletter}/pause'
*/
pause.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return pause.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::pause
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:176
* @route '/app/admin/newsletters/{adminNewsletter}/pause'
*/
pause.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::pause
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:176
* @route '/app/admin/newsletters/{adminNewsletter}/pause'
*/
const pauseForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::pause
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:176
* @route '/app/admin/newsletters/{adminNewsletter}/pause'
*/
pauseForm.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

pause.form = pauseForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::resume
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:187
* @route '/app/admin/newsletters/{adminNewsletter}/resume'
*/
export const resume = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(args, options),
    method: 'post',
})

resume.definition = {
    methods: ["post"],
    url: '/app/admin/newsletters/{adminNewsletter}/resume',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::resume
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:187
* @route '/app/admin/newsletters/{adminNewsletter}/resume'
*/
resume.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return resume.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::resume
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:187
* @route '/app/admin/newsletters/{adminNewsletter}/resume'
*/
resume.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::resume
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:187
* @route '/app/admin/newsletters/{adminNewsletter}/resume'
*/
const resumeForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::resume
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:187
* @route '/app/admin/newsletters/{adminNewsletter}/resume'
*/
resumeForm.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(args, options),
    method: 'post',
})

resume.form = resumeForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::preview
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:207
* @route '/app/admin/newsletters/{adminNewsletter}/preview'
*/
export const preview = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: preview.url(args, options),
    method: 'post',
})

preview.definition = {
    methods: ["post"],
    url: '/app/admin/newsletters/{adminNewsletter}/preview',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::preview
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:207
* @route '/app/admin/newsletters/{adminNewsletter}/preview'
*/
preview.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return preview.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::preview
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:207
* @route '/app/admin/newsletters/{adminNewsletter}/preview'
*/
preview.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: preview.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::preview
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:207
* @route '/app/admin/newsletters/{adminNewsletter}/preview'
*/
const previewForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: preview.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::preview
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:207
* @route '/app/admin/newsletters/{adminNewsletter}/preview'
*/
previewForm.post = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: preview.url(args, options),
    method: 'post',
})

preview.form = previewForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::destroy
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:235
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
export const destroy = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/admin/newsletters/{adminNewsletter}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::destroy
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:235
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
destroy.url = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { adminNewsletter: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { adminNewsletter: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            adminNewsletter: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        adminNewsletter: typeof args.adminNewsletter === 'object'
        ? args.adminNewsletter.uuid
        : args.adminNewsletter,
    }

    return destroy.definition.url
            .replace('{adminNewsletter}', parsedArgs.adminNewsletter.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::destroy
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:235
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
destroy.delete = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::destroy
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:235
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
const destroyForm = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::destroy
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:235
* @route '/app/admin/newsletters/{adminNewsletter}'
*/
destroyForm.delete = (args: { adminNewsletter: string | { uuid: string } } | [adminNewsletter: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const newsletters = {
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    send: Object.assign(send, send),
    cancel: Object.assign(cancel, cancel),
    pause: Object.assign(pause, pause),
    resume: Object.assign(resume, resume),
    preview: Object.assign(preview, preview),
    destroy: Object.assign(destroy, destroy),
}

export default newsletters